import React, { useEffect, useRef, useState } from 'react';
import { TextInput } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import ProjectDetails from './ProjectDetails';

export default function BulkDelete({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const [text, setText] = useState('');
  const setCanSubmitRef = useRef(() => {});

  useEffect(() => {
    setCanSubmitRef.current(text === 'DELETE');
  }, [text]);

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projects()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={ProjectDetails}>
      {({ isLoading, setCanSubmit }) => {
        setCanSubmitRef.current = setCanSubmit;

        return (
          <>
            {`To delete ${ids.length === 1 ? 'this project' : 'these projects'} now, type the word "DELETE" into the box below and click the Delete button. This will also delete all associated data including tasks, time entries, expense items, and resource allocations. This action cannot be undone.`}
            <div style={{ marginTop: '1rem' }}>
              <TextInput
                placeholder="Type DELETE to confirm"
                value={text}
                disabled={isLoading}
                onChange={({ target: { value } }) => setText(value)}
              />
            </div>
          </>
        );
      }}
    </BulkActionModal>
  );
}
